module.exports = __webpack_public_path__ + "static/img/honor_3.1b8687f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_3.jpg
// module id = EZsU
// module chunks = 0